// One shared socket for the whole app (App shell, alarms, live orders).
import io from 'socket.io-client';
import { getBaseURL } from './api';

const socket = io(getBaseURL(), {
  transports: ['websocket', 'polling'],
  withCredentials: true,
});

export default socket;
